<template>
  <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="sidebar leftfloat">
    <div class="grid-content bg-purple">
      <!-- 检索查询 -->
      <div class="tgxz Mt10">
       <div class="title">
        <div class="titleall">Article Search</div>
        <div class="clearfix"></div>
      </div>
      <div class="pd15" style="padding-top:0 !important">
        <Search /> 
      </div>
      </div>
      <!-- 往期杂志 -->
      <div class="tgxz tentn">
        <div class="title">
            <div class="titleall">Past Issues</div>
            <span class="title_more">
              <router-link to="/dlistnum"></router-link>
            </span>
            <div class="clearfix"></div>
        </div>
        <ul class="Npd10">
          <li v-for="(item,index) in getDisnum" :key="index" class="IssueNum" v-if="index<9">
            <div class="leftfloat year" style="width:40px">{{item.PublishYear}}</div>
            <ul class="leftfloat yearList" style="width:73%">
              <li v-for="(item1,index) in item.Issue" :key="index">
                <a @click="tomouthgzh(item1.IssueId)" v-if="isgzh">{{item1.IssueNum}}</a>
                <a @click="tomouth(item1.IssueId)" v-else>{{item1.IssueNum}}</a>
              </li>
              <div class="clearfix"></div>
            </ul>
          </li>
          <div class="clearfix"></div>
        </ul>
      </div>
      <!-- 用户中心 -->
      <!-- <div class="tgxz tentn">
       <div class="title">
        <div class="titleall">User Login</div>
        <div class="clearfix"></div>
      </div>
        <LoginControl class="Pclogin"></LoginControl>
      </div> -->
      <!-- 期刊信息 -->
      <div class="tgxz tentn">
        <div class="title">
          <div class="titleall">Periodical Information</div>
          <div class="clearfix"></div>
        </div>
        <div style="text-align: center;" class="Npd10">
          <img :src="ImgUrl+imgUrl" alt width="100%"/>
        </div>
        <div v-html="Info" class="notice"></div>
      </div>
      

      <!-- <div class="tgxz tentn">
        <div class="title">
        <div class="titleall">Link</div>
        <span class="title_more">
          <router-link to="/Links"></router-link>
        </span>
        <div class="clearfix"></div>
      </div>
        <FrLinks></FrLinks>
      </div> -->
    </div>
  </el-col>
</template>

<script>
import Control from "./page/Control";
import Ranking from "./page/Ranking";
import FrLinks from "./page/FrLinks";
import LoginControl from "../LoginControl";
import Search from '../Home/Search.vue';
export default {
  name: "Sidebar",
  data() {
    return {
      activeName: "first",
      type: 1,
      activeNamea: "firsta",
      activeNameb: "firstb",
      slqk: "",
      data: {},
      Volume: "",
      newYears: "",
      newMonth: "",
      SetItem: {},
      ISSN: "",
      CN: "",
      imgUrl:"",
      YearIssue_NoTtitle:"",
      getDisnum:[],
      Info:'',
      Count:0,
      CurrentDay:0,
      CurrentLast:0,
      OnlineNumber:0,
    };
  },
  created(){
    this.getDisnumList(); //获取过刊目录
    this.getProfile();
    this.getAllSum();
  },
  props:['isgzh'],
  components: { Control, FrLinks, LoginControl,Ranking,Search },
  mounted() {
    if (this.$route.path == "/FixedBody") {
      this.activeName = "first";
    } else if (this.$route.path === "/Authorgarden") {
      this.activeName = "two";
    }
    if (sessionStorage.getItem("slqk")) {
      this.slqk = JSON.parse(sessionStorage.getItem("slqk"));
    } else {
      let params = [80, 8, 9, 1400];
      this.$store.dispatch("_getHeader", params).then(res => {
        res.data.Data.map(item=>{
          if(item.ItemId==1400){
            this.slqk = item.Body;
        sessionStorage.setItem("slqk", JSON.stringify(item.Body));
        }
        })
        
        
      });
    }
    if (sessionStorage.getItem("newYears")) {
      this.data = JSON.parse(sessionStorage.getItem("newYears"));
      this.Volume = this.data.Volume;
      this.newYears = this.data.newYears

      this.imgUrl=this.data.CoverGUID+this.data.CoverSuffix
      this.YearIssue_NoTtitle=this.data.YearIssue_NoTtitle
    } else {
      this.$store.dispatch("_getYear", { Id: -1 }).then(res => {
        if(res.data.Data){
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
        let data = {
         newYears:res.data.Data.Publish_Date,
            Volume:res.data.Data.Volume,
            CoverGUID:res.data.Data.CoverGUID,
            CoverSuffix:res.data.Data.CoverSuffix,
            YearIssue_NoTtitle:res.data.Data.YearIssue_NoTtitle
        };
        this.Volume = res.data.Data.Volume;
         this.newYears = res.data.Data.Publish_Date
        this.imgUrl=res.data.Data.CoverGUID+res.data.Data.CoverSuffix
        this.YearIssue_NoTtitle=res.data.Data.YearIssue_NoTtitle
        sessionStorage.setItem("newYears", JSON.stringify(data));
        }
        
        
      });
    }
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map(item => {
        if (item.SetItemID == 5000) {
          this.ISSN = item.Item_Value;
        }
        if (item.SetItemID == 5010) {
          this.CN = item.Item_Value;
        }
      });
    } else {
      let params = [
        1000,
        1001,
        4530,
        6018,
        6019,
        230,
        6055,
        5000,
        5010,
        99,
        96,
        11,
        2960
      ];
      this.$store.dispatch("_getSet", params).then(res => {
        this.SetItem = res.data.Data;
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
        this.SetItem.map(item => {
          if (item.SetItemID == 5000) {
            this.ISSN = item.Item_Value;
          }
          if (item.SetItemID == 5010) {
            this.CN = item.Item_Value;
          }
        });
      });
    }
  },
  methods: {
    getAllSum(){
       this.$store.dispatch("_getAllSum").then(res=>{
          this.Count=res.data.Data.Count
          this.CurrentDay=res.data.Data.CurrentDay
          this.CurrentLast=res.data.Data.CurrentLast
          this.OnlineNumber=res.data.Data.OnlineNumber
       }).catch(err=>{
          console.log(err)
       })
    },
    handleClick(tab, event) {},
    handleClicka(tab, event) {},
    onick() {
      if (this.activeName == "first") {
        this.$router.push({
          path: "/NewsList?ColumnId=5"
        });
      } else if (this.activeName == "two") {
        this.$router.push({
          path: "/Authorgarden"
        });
      }
    },
    onicka(){
       if (this.activeNamea == "firsta") {
        this.$router.push({
          path: "/DownloadlistViewlist?Key=ReadRank"
        });
      } else if (this.activeNamea == "twoa") {
        this.$router.push({
          path: "/DownloadlistViewlist?Key=ViewRank"
        });
      }
    },
    //获取过刊目录列表
    getDisnumList(){
      this.$store.dispatch("_getgok").then(res=>{
        if(res.data.IsSuccess){
          this.getDisnum=res.data.Data.Year
        }
      })
    },
    tomouth(id,type) {
        this.$router.push({
          path: '/OAList?IssueId=' + id
        })
      },
      tomouthgzh(id,type) {
        this.$router.push({
          path: '/gzhOAList?IssueId=' + id
        })
      },
      getProfile(){
      let data = [13]
			this.$store.dispatch("_getHeader",data).then(res=>{
        if(res.data.IsSuccess){
          if(res.data.Data.length>0) {
            this.Info=res.data.Data[0].Body
            console.log(this.Info)
          }
        }
      })
    }, 
    
  }
};
</script>

<style>
.qktext p{
  line-height: 24px;
}
.qkjjtext img{
  height: 210px;
  display: inline-block;
  background: #dedede;
}
.cover_info{line-height:27.5px;font-size: 14px; color: #000;}
.cover_info .title{width: 70px;}
.cover_info_text{width: 65%;}
@media (max-width:1200px) {
  .cover_info{line-height: 25px;}
  .cover_info_text{width: 60%;}
}
@media (max-width:420px) {
  .cover_info{line-height: 26px;}
}
.IssueNum{width: 100%; float: left; line-height: 30px;}
.year{ font-weight: bold; color: #ac0e06;background:url("../../assets/images/arrow.gif") no-repeat left center; padding-left: 12px; width: 40px;}
.yearList{ width: 80%;}
.yearList li a{ display: inline-block;}
.IssueNum ul li{float: left; margin: 0 6px; background: none !important;}
</style>
